The identifier of the `WebhookSubscription` delivering the events.
